import clsx from 'clsx';

/**
 * The plan a settings page needs: `sm` right-aligned on its sidebar row, `md`
 * beside the page title.
 */
export const SettingsPlanTag = ({
  label,
  size = 'sm',
}: {
  label: string;
  size?: 'sm' | 'md';
}) => (
  <span
    className={clsx(
      'inline-flex shrink-0 items-center rounded bg-[#0C41BB]/12 font-medium text-[#0C41BB]',
      size === 'sm'
        ? 'h-[17px] px-1.5 text-[10.5px]'
        : 'h-5 px-2 text-[11.5px]',
    )}
  >
    {label}
  </span>
);
